import React from 'react';
// import { Button } from 'antd';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./LinkModel";

export default class UI extends DiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    render() {

        return (
            <a className={"diagram-ui " + (this.props.className || "")} style={this.props.model.toStyle()}
                href={this.props.model.href}
                target={this.props.model.target}
                onClick={e => this.onClick && this.onClick(e)}>
                {this.props.model.text}
            </a>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "超链接",
    catalog: "其他",
    svg: "#anticon-lianjie2",
    uiGetter: (model) => <UI model={model} />
});